import * as React from 'react';



export default class ModalFooter extends React.PureComponent {
    constructor(props) {
        super(props);
    }
    

    renderFooter()
    {
        let footer="";
        if(this.props.isLogoFooter)
        {
            footer=
              <div className="modalFooter">
                    <button type="button" className="btn btnRed" onClick={this.props.onRemoveClick}>{this.props.removeButtonText}</button>
                    <button type="button" className="btn link" onClick={this.props.onClose}>{this.props.closeButtonText}</button>
                </div>
        }
        else{
      footer=
            <div className="modalFooter">
            <button type="button" className={this.props.successButtonClass || "btn default buttonGradient"} onClick={this.props.onConfirmClick}>{this.props.successButtonText}</button>
            <button type="button" className="btn link" onClick={this.props.onClose}>{this.props.closeButtonText}</button>
        </div>
        }

        return footer;
    }

    render() {
    return this.renderFooter();
      
    }
}